
import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { I18nModule, WindowRef } from '@spartacus/core';
import { PaginationModule, SpinnerModule } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { GenLoadingEnum } from 'src/app/generac/enums/loading.enum';
import { GenDocumentsListPaginationMapped, GenDocumentsListPagination, GenDocumentsResponse, GenDocument } from 'src/app/generac/models/document.model';
import { GenDocumentService } from 'src/app/generac/services/document.service';
import { GenDocumentListItemComponent } from './document-list-item/document-list-item.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'gen-document-list',
    templateUrl: './document-list.component.html',
    imports: [
      CommonModule,
      PaginationModule,
      I18nModule,
      GenDocumentListItemComponent,
      SpinnerModule,
    ]
})
export class GenDocumentListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  @Input() searchBy: string;
  @Input() spSearchCode: string;
  currentPage: number = 0;
  isMobileView: boolean;
  documents: GenDocument[];
  pagination: GenDocumentsListPaginationMapped | GenDocumentsListPagination;
  GenLoadingEnum = GenLoadingEnum;
  loading: GenLoadingEnum = GenLoadingEnum.Idle;

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  constructor(
    protected documentService: GenDocumentService,
    protected winRef: WindowRef,
  ) {
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.getDocuments().subscribe()
    )
  }

  getDocuments() {
    this.loading = GenLoadingEnum.Loading;
    return this.documentService.getDocuments(this.searchBy, this.spSearchCode, this.currentPage).pipe(
      tap((res: GenDocumentsResponse) => {
        this.documents = res.documents;
        this.pagination = res.pagination;
      }),
      catchError(() => this.loading = GenLoadingEnum.Failed),
      finalize(() => this.loading = GenLoadingEnum.Loaded)
    )
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.subscription.add(
      this.getDocuments().subscribe()
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
